module.exports = __webpack_public_path__ + "static/media/26UNRWA10.86d3302d.jpg";